//转接号码
export default {
  mobileServer: {
    chinaMobile: {
      bind: {
        start: '**004*',
        end: '#'
      },
      busy: {
        open: {
          start: '**67*',
          end: '#'
        },
        close: {
          start: '##67#',
          end: ''
        }
      },
      noAnswer: {
        open: {
          start: '**61*',
          end: '#'
        },
        close: {
          start: '##61#',
          end: ''
        }
      },
      unConnection: {
        open: {
          start: '**62*',
          end: '#'
        },
        close: {
          start: '##62#',
          end: ''
        }
      },
    },
    chinaUnion: {
      bind: {
        start: '**004*',
        end: '#'
      },
      busy: {
        open: {
          start: '**67*',
          end: '#'
        },
        close: {
          start: '##67#',
          end: ''
        }
      },
      noAnswer: {
        open: {
          start: '**61*',
          end: '#'
        },
        close: {
          start: '##61#',
          end: ''
        }
      },
      unConnection: {
        open: {
          start: '**62*',
          end: '#'
        },
        close: {
          start: '##62#',
          end: ''
        }
      },
    },
    chinaTelcom: {
      bind: {
        start: '**004*',
        end: '#',
      },
      busy: {
        open: {
          start: '*90',
          end: ''
        },
        close: {
          start: '*900',
          end: ''
        }
      },
      noAnswer: {
        open: {
          start: '*92',
          end: ''
        },
        close: {
          start: '*920',
          end: ''
        }
      },
      unConnection: {
        open: {
          start: '*68',
          end: ''
        },
        close: {
          start: '*950',
          end: ''
        }
      },
    },
    unkown: {
      bind: {
        start: '**004*',
        end: '#'
      },
      busy: {
        open: {
          start: '**67*',
          end: '#'
        },
        close: {
          start: '##67#',
          end: ''
        }
      },
      noAnswer: {
        open: {
          start: '**61*',
          end: '#'
        },
        close: {
          start: '##61#',
          end: ''
        }
      },
      unConnection: {
        open: {
          start: '**62*',
          end: '#'
        },
        close: {
          start: '##62#',
          end: ''
        }
      },
    },
  },
}



// WEBPACK FOOTER //
// ./src/utils/shouji.js